import { NgModule } from '@angular/core';
import { TreatmentScheduleComponent } from './treatment-schedule.component';

@NgModule({
  declarations: [TreatmentScheduleComponent],
  exports: [TreatmentScheduleComponent],
})
export class TreatmentScheduleModule {}
